module.exports = __webpack_public_path__ + "img/vcard-preview.1d645672.webp";